import { Localize } from '@/i18n/Localize';
import { sharedPortuguese } from '@/i18n/shared';
import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    toggleVisibility();
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return <Localize messages={sharedPortuguese}>{(
    <Button
      data-floating-page-control
      onClick={scrollToTop}
      size="icon"
      className={cn(
        "fixed bottom-24 right-6 h-12 w-12 rounded-full shadow-lg z-[60] transition-all duration-300 bg-primary text-primary-foreground hover:bg-primary/90",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16 pointer-events-none"
      )}
      aria-label="Back to top"
    >
      <ArrowUp className="h-5 w-5" />
    </Button>
  )}</Localize>;
};

export default BackToTop;
